import { useContext, useEffect, useState } from 'react';
import { UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom';

const useConfirmExit = (cb: () => void, when = true, confirmed: boolean) => {
  const { navigator } = useContext(NavigationContext);
  const [pathname, setPathname] = useState('');

  useEffect(() => {
    // FIXME: re-creating context functions everytime state change. Use useCallback
    if (!when) {
      return;
    }

    const push = navigator.push;

    if (!confirmed) {
      navigator.push = (...args: Parameters<typeof push>) => {
        if (!pathname) {
          const [location]: any = args;
          setPathname(`${location.pathname}${location.search}`);
          cb();
        }
      };
    }

    return () => {
      navigator.push = push;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, when, confirmed]);

  return { pathname, setPathname };
};

export const useNavigationBlocker = (when = true, confirmed: boolean) => {
  const [isOpenedModal, setIsOpenedModal] = useState(false);

  useEffect(() => {
    if (when) {
      window.onbeforeunload = () => {
        return '';
      };
    }

    return () => {
      window.onbeforeunload = null;
    };
  }, [when]);

  const cb = () => setIsOpenedModal(true);

  const { pathname, setPathname } = useConfirmExit(cb, when, confirmed);

  return { isOpenedModal, setIsOpenedModal, pathname, setPathname };
};
